import React from 'react'
import { useEffect, useState } from 'react';
import Axios from 'axios';
import Dropdown from 'react-dropdown';
import { HiSwitchHorizontal } from 'react-icons/hi';
import { BiSolidUserCircle } from "react-icons/bi";
import { SiTether } from "react-icons/si";
import { FaEthereum } from "react-icons/fa";
import { SiBitcoinsv } from "react-icons/si";
import './swap.css'

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";

import 'react-dropdown/style.css';

const Swap = () => {

  const [info, setInfo] = useState([]);
  const [input, setInput] = useState("");
  const [from, setFrom] = useState("usd");
  const [to, setTo] = useState("inr");
  const [options, setOptions] = useState([]);
  const [output, setOutput] = useState(0);

  // Calling the api whenever the dependency changes
  useEffect(() => {
      Axios.get(
`https://cdn.jsdelivr.net/gh/fawazahmed0/currency-api@1/latest/currencies/${from}.json`)
          .then((res) => {
              setInfo(res.data[from]);
              console.log("from "+info)
          })
  }, [from]);

  // Calling the convert function whenever
  // a user switches the currency
  useEffect(() => {
      setOptions(Object.keys(info));
      convert();
  }, [info, convert])

  // Function to convert the currency
  function convert() {
      var rate = info[to];
      setOutput(input * rate);
  }

  


  return (
<>
<div className='swapcontainer'>












  <div>
    <h2>Earn even more when you swap your Account balance to and from crypto.</h2>
    
  </div>

<div className="coinflex">
<div className="coinuser">
  <div className="coinuse">
  <BiSolidUserCircle size={52} style={{marginInline:'auto'}}color="#29302D"/>
  <h2> $0.00</h2>
  <p>Account Balance</p>
  </div>
  </div>
  <div className="coincard">
    <div className="coincardin" >
  <div >
<SiBitcoinsv size={32} style={{marginInline:'auto'}}color="#29302D"/>
  </div>
  <h2>0 &ensp; &emsp;BTC</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div >
<FaEthereum size={32} style={{marginInline:'auto'}}color="#29302D"/>
  </div>
  <h2>0 &ensp; &emsp;ETH</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div >
<SiTether size={32} style={{marginInline:'auto'}}color="#29302D"/>
  </div>
  <h2>0&ensp; &emsp;USDT</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div >
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-5.573-12.786L9.252 24h12.875L23 20.429h-7.722l.848-3.483 1.427-.571.68-2.75-1.41.571L18.342 8h-5.129l-2.081 8.429-1.444.58L9 19.768l1.427-.554z" fill="#29302D"/></svg>
  </div>
  <h2>0 &ensp; &emsp;LTC</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div >
    <svg fill="#29302D" height="36" viewBox="0 0 24 24" width="36" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m13.75 10.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="m10.25 10.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="m15.5 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="m17.1504 10.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m17.1504 16.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m19.75 13.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m6.7998 10.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m6.7998 16.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m4.2002 13.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m15.9004 6.4502c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m8.09961 6.4502c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m12.0498 7.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m15.9004 20.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m8.09961 20.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m12.0498 19.4502c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm0-1.5c-.14 0-.25.11-.25.25 0 .28.5.28.5 0 0-.14-.11-.25-.25-.25z"/><path d="m8.5 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="m10.25 16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="m13.75 16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="m12.0002 3.4502c-.56 0-1.01-.45-1.01-1s.45-1 1-1 1 .45 1 1-.43 1-.99 1z"/><path d="m17.2502 3.6001c-.42 0-.76-.34-.76-.75s.34-.75.75-.75.76.34.76.75-.33.75-.75.75z"/><path d="m6.75 3.6001c-.41 0-.75-.34-.75-.75s.33-.75.75-.75h.01001c.41 0 .75.34.75.75s-.34001.75-.76001.75z"/><path d="m12.0002 22.5c-.56 0-1.01-.45-1.01-1s.45-1 1-1 1 .45 1 1-.43 1-.99 1z"/><path d="m17.2502 21.8501c-.42 0-.76-.34-.76-.75s.34-.75.75-.75.76.34.76.75-.33.75-.75.75z"/><path d="m6.75 21.8501c-.41 0-.75-.34-.75-.75s.33-.75.75-.75h.01001c.41 0 .75.34.75.75s-.34001.75-.76001.75z"/><path d="m1.5498 13c-.549995 0-.999995-.44-.999995-1 0-.55.45-1 .999995-1 .55 0 1 .45 1 1s-.45 1-1 1z"/><path d="m3.75 17.7502c-.41 0-.75-.33-.75-.75v-.01c0-.41.34-.75.75-.75s.75.34.75.75-.34.76-.75.76z"/><path d="m3.75 7.75977c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.33.75.74v.01c0 .41-.34.75-.75.75z"/><path d="m22.5 13c-.55 0-1-.44-1-1 0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1z"/><path d="m20.2998 17.7502c-.41 0-.75-.33-.75-.75v-.01c0-.41.34-.75.75-.75s.75.34.75.75-.34.76-.75.76z"/><path d="m20.2998 7.75977c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.33.75.75v.01c0 .4-.34.74-.75.74z"/></g></svg>

  </div>
  <h2>0 &ensp; &emsp;ADA</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div style={{height:32, width:32}} >
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 381" fill="#29302D"><path d="M117.512 159.61l73.765-73.762 73.801 73.8L308 116.727 191.277 0 74.594 116.688zm-73.23-12.618l42.917 42.918-42.918 42.918L1.36 189.91zm73.23 73.23l73.765 73.762 73.801-73.796 42.945 42.898-116.746 116.746L74.59 263.148l-.063-.058zm263.687-30.292l-42.918 42.922-42.926-42.918 42.922-42.926zm0 0"/><path d="M234.813 189.895h.019l-43.555-43.555-32.187 32.187h-.004l-3.695 3.7-7.688 7.687.059.063 43.515 43.515 43.555-43.554.02-.024zm0 0"/></svg>
  </div>
  <h2>0 &ensp; &emsp;BNB</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div style={{height:32, width:32}} >
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" fill="#29302D"><path d="M192.281 73.586a118.68 118.68 0 00-29.562 3.707v-.004C99.438 93.445 61.239 157.785 77.41 221.004c16.172 63.215 80.582 101.371 143.871 85.215 63.285-16.153 101.48-80.496 85.313-143.711-13.649-53.336-61.633-88.832-114.313-88.922zM0 74.129v236.285h109.164c-37.219-26.086-61.547-69.277-61.547-118.144 0-48.864 24.328-92.055 61.547-118.141zm274.836 0c37.219 26.086 61.547 69.277 61.547 118.14 0 48.868-24.328 92.06-61.547 118.145H384V74.13zm-85.988 38.969l5.863 22.914c10.707-2.04 19.07-2.035 27.21 1.273 10.532 4.274 12.97 15.746 13.466 18.504.496 2.758.64 8.277-.88 12.246-1.515 3.977-6.468 8.828-6.468 8.828s7.238-.3 12.996 2.098c5.746 2.402 10.961 7.89 13.156 17.316 2.207 9.422 2.664 19.22-4.336 27.336-6.832 7.914-15.414 11.332-19.449 12.938l-.304.12c-1.922.77-5.258 1.915-8.86 3.063l5.871 22.946-14.14 3.613-5.778-22.578-10.773 2.75 5.777 22.574-14.14 3.613-5.774-22.582-27.824 7.102-1.43-17.711 8.457-2.156c2.84-.73 3.961-1.293 4.864-2.715.902-1.426.726-3.211.37-4.602l-14.949-58.453c-.937-3.66-1.488-4.574-3.652-6.027-2.168-1.453-6.195-.692-8.43-.117l-8.175 2.086-3.75-14.672 27.82-7.098-5.797-22.64 14.145-3.61 5.789 22.645 10.77-2.75-5.79-22.645zm6.203 40.68c-5.016-.024-8.508.753-12.403 1.687-4.441 1.066-8.835 2.61-8.835 2.61l6.968 27.26s6.664-1.487 11.766-3.003c5.105-1.516 10.289-4.098 13.691-7.289 3.41-3.191 4.778-7.2 3.332-12.313-1.453-5.117-6-8.593-12.27-8.894a54.06 54.06 0 00-2.25-.059zm15.097 40.6c-3.277.024-6.546.34-9.773.938-7.125 1.329-15.992 4.082-15.992 4.082l7.75 30.297s9.437-2.191 15.594-4.261c6.16-2.063 12.23-5.297 15.015-7.91 2.778-2.606 5.969-6.38 4.196-13.305-1.774-6.934-7.141-8.656-10.122-9.301-1.492-.324-3.82-.555-6.668-.54zm0 0"/></svg>
  </div>
  <h2>0 &ensp; &emsp;BCH</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div style={{height:32, width:32}} >
  <svg viewBox="0 0 411 512" xmlns="http://www.w3.org/2000/svg" fill="#29302D"><path d="M80.241 402.285a6.929 6.929 0 00-9.665 1.624L2.047 500.16a6.928 6.928 0 1011.289 8.036l68.53-96.245a6.927 6.927 0 00-1.625-9.665zm16.576 31.58a6.933 6.933 0 00-9.67 1.59l-38.115 53.133a6.926 6.926 0 001.592 9.67 6.93 6.93 0 009.67-1.588l38.115-53.131a6.934 6.934 0 00-1.592-9.674zM410.4 91.077C410.4 44.88 394.616.221 394.616.221S335.71-3.821 286.433 22.74c-49.283 26.56-67.954 60.445-77.195 76.038-9.24 15.592-28.49 48.895-28.49 48.895s-42.155-.767-75.46 17.712c-33.3 18.477-53.705 53.128-53.705 53.128s22.137-6.351 43.312-5.771c21.175.58 42.35 9.428 42.35 9.428s-5.005 7.506-4.042 18.477c.424 4.822 6.865 11.683 15.734 19.151a193.894 193.894 0 00-4.085 5.535c-31.617 44.673-38.84 93.908-16.129 109.986 22.713 16.072 66.754-7.105 98.37-51.769a193.982 193.982 0 002.948-4.292c8.052 5.073 14.951 8.424 19.239 8.208 11.359-.58 21.175-12.514 21.175-12.514s21.66 27.432 27.142 41.294c5.488 13.86 7.51 38.691 7.51 38.691s24.253-28.586 31.912-70.814c7.66-42.228-11.126-72.118-11.126-72.118s21.368-26.175 43.312-52.74c21.946-26.568 41.195-61.988 41.195-108.188zM219.627 313.184c-20.94 28.35-50.799 41.808-66.7 30.066-15.899-11.745-11.808-44.244 9.133-72.596.083-.115.171-.223.257-.338 8.458 6.322 17.437 12.608 24.977 18.073 9.931 7.202 21.809 16.468 32.766 24.172-.151.208-.28.415-.433.623zm80.088-145.3c-26.048 0-47.164-21.116-47.164-47.163 0-26.048 21.116-47.162 47.164-47.162 26.047 0 47.16 21.114 47.16 47.162 0 26.047-21.113 47.163-47.16 47.163z"/></svg>
  </div>
  <h2>0 &ensp; &emsp;XLM</h2>
  </div>
  </div>

  <div className="coincard">
    <div className="coincardin" >
  <div style={{height:32, width:32}} >
  <svg height="32" viewBox="0 0 226.777 226.777" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m113.48.183c-62.572 0-113.297 50.725-113.297 113.297s50.725 113.297 113.297 113.297 113.297-50.726 113.297-113.297c0-62.572-50.725-113.297-113.297-113.297zm47.419 163.777c-7.365 12.656-23.905 17.119-36.941 9.97-13.037-7.149-17.635-23.205-10.268-35.862 3.068-5.272 1.153-11.96-4.28-14.941-5.356-2.937-12.132-1.166-15.261 3.941h-.002v-.021c-.044.078-.083.155-.128.232-7.365 12.656-23.904 17.12-36.94 9.97-13.038-7.149-17.636-23.207-10.271-35.86 7.367-12.657 23.905-17.12 36.944-9.969 4.357 2.39 7.765 5.779 10.107 9.7v-.014l.002-.002c3.248 5.032 10.055 6.654 15.341 3.603 5.362-3.095 7.125-9.824 3.936-15.03-7.651-12.494-3.42-28.645 9.451-36.072 12.869-7.428 29.506-3.321 37.159 9.172 7.651 12.495 3.422 28.645-9.451 36.073a27.612 27.612 0 0 1 -13.697 3.694l.012.005v.002c-6.175.207-11.081 5.161-11.007 11.191.073 6.11 5.239 11.008 11.533 10.936l-.039.021a27.627 27.627 0 0 1 13.533 3.401c13.034 7.151 17.632 23.206 10.267 35.86z" fill="#29302D"/></svg>
  </div>
  <h2>0 &ensp; &emsp;XRP</h2>
  </div>
  </div>
 
  <div className="coincard">
    <div className="coincardin" >
  <div style={{height:32, width:32}} >
  <svg fill="#29302D" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm4.3 14.69c-.1.04-.2.06-.3.06-.29 0-.56-.17-.69-.45l-3.31-7.45-1.07 2.4h1.07c.41 0 .75.34.75.75s-.34.75-.75.75h-1.73l-1.58 3.55c-.17.38-.61999.55-.98999.38-.38-.17-.55-.61-.38-.99l1.30999-2.95h-.63c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.28998l2.02002-4.55c.24-.54 1.13-.54 1.37 0l4 9c.17.38 0 .83-.38 1z" fill="#000"/></svg>
  </div>
  <h2>0&ensp; &emsp;AAVE</h2>
  </div>
  </div>
  

  <div className="coincard">
    <div className="coincardin" >
  <div style={{height:32, width:32}} >
  <svg fill="#29302D" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m19.9992 3.5h-14.50001c-.31 0-.60999.15-.79999.4l-1.5 2c-.49.66-.02001 1.6.79999 1.6h14.50001c.31 0 .61-.15.8-.4l1.5-2c.49-.66.02-1.6-.8-1.6z"/><path d="m3.99919 10h14.50001c.31 0 .61.15.8.4l1.5 2c.49.66.02 1.6-.8 1.6h-14.50001c-.31 0-.60999-.15-.79999-.4l-1.5-2c-.49-.66-.02001-1.6.79999-1.6z"/><path d="m19.9992 16.5h-14.50001c-.31 0-.60999.15-.79999.4l-1.5 2c-.49.66-.02001 1.6.79999 1.6h14.50001c.31 0 .61-.15.8-.4l1.5-2c.49-.66.02-1.6-.8-1.6z"/></g></svg>
  </div>
  <h2>0 &ensp; &emsp;SOL</h2>
  </div>
  </div>
</div>

</div>




<div className="tradv">
  <div className="tradeview">
  <AdvancedRealTimeChart theme="dark" autosize></AdvancedRealTimeChart>
  </div>

   <div className="convert">
            <div className="convert-heading">
                <h1>Swap your Crypto</h1>
            </div>
            <div className="convert-contain">
                
                <div className="middle">
                    <h3>Source Account:</h3>
                    <Dropdown options={options}
                        onChange={(e) => { setFrom(e.value) }}
                        value={from} placeholder="From"  />
                </div>
               
                <div className="right">
                    <h3>Destination Account:</h3>
                    <Dropdown options={options}
                        onChange={(e) => { setTo(e.value) }}
                        value={to} placeholder="To"  />
                </div>
            </div>
            <div className="left">
                    <h3>Amount:</h3>
                    <input type="number"
                        placeholder="Enter amount"
                        onChange={(e) => setInput(e.target.value)} />
                </div>
            <div className="result">
               
                <h2>Converted Amount:</h2>
                <p>{input + " " + from + " = " + output.toFixed(2) + " " + to}</p>
 
            </div>


    <button className="swapBut">
      Swap
    </button>
        </div>

        </div>

        
</>

  )
}

export default Swap